import { render, staticRenderFns } from "./Item2SimpleText.vue?vue&type=template&id=18355714&"
import script from "./Item2SimpleText.vue?vue&type=script&lang=js&"
export * from "./Item2SimpleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports